import { render, staticRenderFns } from "./Flashboard.vue?vue&type=template&id=4c498271&scoped=true&"
import script from "./Flashboard.vue?vue&type=script&lang=js&"
export * from "./Flashboard.vue?vue&type=script&lang=js&"
import style0 from "./Flashboard.vue?vue&type=style&index=0&id=4c498271&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c498271",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
